import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { useNavigate, useParams } from 'react-router-dom'
import LandingPageTemplateForm from './LandingPageTemplateForm'
import usePermissions from '@/hooks/usePermissions'
import Redirect from '@/components/Redirect'

const mapStateToProps = () => ({})

const LandingPageTemplateCreate = ({ dispatch }) => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const routeParams = useParams()
  const { type } = routeParams

  const canCreate = usePermissions(
    type === 'system' ? 'landingpageSystem_create' : 'landingpagePerson_create',
  )

  const onSubmit = payload => {
    dispatch({
      type: 'landingPage/createLandingPage',
      payload,
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: { message: t('messages.landing_template_created'), severity: 'success' },
        })
        navigate(`/phish_template_landing/${type}`, { replace: true })
      },
      errorCallback: message => {
        dispatch({
          type: 'app/notify',
          payload: { message, severity: 'error' },
        })
      },
    })
  }

  if (!canCreate) return <Redirect />

  return <LandingPageTemplateForm onSubmit={onSubmit} type={type} />
}

export default connect(mapStateToProps)(LandingPageTemplateCreate)
